import React, { createContext, useContext } from 'react';

import { StyledAvatar } from 'components/avatars';
import TextParseComponent from 'components/feed/TextParseComponent';
import Employee from 'models/employee';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';
import { themeColors } from 'themes/clients/baseTheme';

import { convertDateToString4, convertDateToString4Reverse } from 'constants/helper';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export const CommentDisplayContext = createContext();

function FromName({ className, ...props }) {
  const { fromEmployee } = useContext(CommentDisplayContext);
  return (
    <StyledTypography className={className} {...props}>
      {fromEmployee?.displayName}
    </StyledTypography>
  );
}

function HistoryFromName({ isColon, ...props }) {
  const { fromEmployee } = useContext(CommentDisplayContext);
  return (
    <TextBodyMedium bold {...props}>
      {fromEmployee?.displayName}
      {isColon ? ': ' : ''}
    </TextBodyMedium>
  );
}

function EmployeeImage({ className, src, ...props }) {
  const { fromEmployee } = useContext(CommentDisplayContext);
  return <StyledAvatar className={className} src={fromEmployee?.getProfileImage()} size="smaller" {...props} />;
}

function Message({ className, ...props }) {
  const { text, macrosRes } = useContext(CommentDisplayContext);
  return text ? (
    <StyledTypography className={className} {...props}>
      <TextParseComponent text={text} res={macrosRes} />
    </StyledTypography>
  ) : null;
}

function HistoryMessage({ ...props }) {
  const { text, macrosRes } = useContext(CommentDisplayContext);
  return text ? (
    <TextBodyMedium {...props}>
      <TextParseComponent text={text} res={macrosRes} />
    </TextBodyMedium>
  ) : null;
}

function CreatedAt({ className, ...props }) {
  const { createdDate } = useContext(CommentDisplayContext);
  return createdDate ? (
    <StyledTypography color="textSecondary" className={className} {...props}>
      {convertDateToString4(createdDate)}
    </StyledTypography>
  ) : null;
}

function CreatedAtHistory({ ...props }) {
  const { createdDate } = useContext(CommentDisplayContext);
  return createdDate ? (
    <TextLabel color={themeColors.text.g2} whiteSpace="nowrap" {...props}>
      {convertDateToString4Reverse(createdDate)}
    </TextLabel>
  ) : null;
}

export default function ModularCommentDisplay({
  fromEmployee = new Employee(),
  text,
  createdDate,
  macrosRes,
  addMention,
  className,
  children,
}) {
  const contextValue = { fromEmployee, text, createdDate, macrosRes, addMention };
  return (
    <CommentDisplayContext.Provider value={contextValue}>
      <Container className={className}>{children}</Container>
    </CommentDisplayContext.Provider>
  );
}

ModularCommentDisplay.From = FromName;
ModularCommentDisplay.Message = Message;
ModularCommentDisplay.HistoryFromName = HistoryFromName;
ModularCommentDisplay.HistoryMessage = HistoryMessage;
ModularCommentDisplay.EmployeeImage = EmployeeImage;
ModularCommentDisplay.CreatedAt = CreatedAt;
ModularCommentDisplay.CreatedAtHistory = CreatedAtHistory;

const Container = styled.div``;
